import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { IAdProduct } from "../../whatsappAdProducts.types";
import { requestUpsertAdProduct } from "./upsertAdProduct.request";

const useUpsertAdProduct = (
  options?: MutationOptions<IAdProduct, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestUpsertAdProduct,
    ...options
  });
};

export default useUpsertAdProduct;
